import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import {
  JointemploymentDetailsFromOne,
  JointemploymentDetailsFromTwo,
  JointemploymentDetailsFromThree,
  JointemploymentDetailsFromFour,
} from "app/utils/types";

interface StepsDataTypes {
  formOne?: JointemploymentDetailsFromOne;
  formTwo?: JointemploymentDetailsFromTwo;
  formThree?: JointemploymentDetailsFromThree;
  formFour?: JointemploymentDetailsFromFour;
}
interface StepState {
  currentStep: number;
  stepsData: StepsDataTypes;
}
const initialState: StepState = {
  currentStep: 0,
  stepsData: {},
};
export const jointemploymentDetails = createSlice({
  name: "jointemploymentDetails",
  initialState,
  reducers: {
    nextStep: (state) => {
      state.currentStep += 1;
    },
    prevStep: (state) => {
      if (state.currentStep >= 1) state.currentStep -= 1;
    },
    setStep: (state, action: PayloadAction<number>) => {
      state.currentStep = action.payload;
    },
    addStepsData: (state, action: PayloadAction<StepsDataTypes>) => {
      state.stepsData = { ...state.stepsData, ...action.payload };
    },
  },
});

export const { nextStep, prevStep, setStep, addStepsData } =
  jointemploymentDetails.actions;

export default jointemploymentDetails.reducer;
